<div class="common-popup-modal">
    <mat-card style="box-shadow: none; padding: 0; border-radius: 12px; margin: 0;">
        <mat-card-title class="popup-title">
            {{ data.title || 'Confirm' }}
        </mat-card-title>
        <mat-card-content style="padding: 0;">
            <p class="popup-message" *ngIf="data.message">{{ data.message }}</p>
            <!-- button wrapper -->
            <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px" fxFlexFill>
                <button [mat-dialog-close]="data" cdkFocusInitial type="button" class="btn-confirm">
                    {{ data.action || 'Confirm' }}
                </button>
                <button mat-dialog-close type="button" class="btn-cancel-popup">Cancel</button>
            </div>
        </mat-card-content>
    </mat-card>
</div>
